import { EHighLow } from "@domains/features/Markets/Equity/entities/iAllTimeHighLow";
import { EGLType } from "@domains/features/Markets/Equity/entities/iTopGainersLosers";
import { combineReducers } from "redux";
import createNamedWrapperReducer from "../../wrapperReducer";
import allTimeHighLow from "./allTimeHighLow";
import topGainersLosers from "./topGainersLosers";
import { EDrivingMarketSectionType } from "@domains/features/Markets/Equity/entities/iDrivingMarket";
import outUnderPerformers from "./outUnderPerformers";
import priceBuzzer from "./priceBuzzer";
import upperLowerCircuit from "./upperLowerCircuit";
import weekHighLow from "./weekHighLow";
import volumeBuzzer from "./volumeBuzzer";
import indexPullersDraggers from "./indexPullersDraggers";
export default combineReducers({
    gain: createNamedWrapperReducer(topGainersLosers, EGLType.GAIN),
    loss: createNamedWrapperReducer(topGainersLosers, EGLType.LOSS),
    high: createNamedWrapperReducer(allTimeHighLow, EHighLow.HIGH),
    low: createNamedWrapperReducer(allTimeHighLow, EHighLow.LOW),
    out: createNamedWrapperReducer(outUnderPerformers, EDrivingMarketSectionType.OUT),
    under: createNamedWrapperReducer(outUnderPerformers, EDrivingMarketSectionType.UNDER),
    price: createNamedWrapperReducer(priceBuzzer, EDrivingMarketSectionType.PRICE),
    upper: createNamedWrapperReducer(upperLowerCircuit, EDrivingMarketSectionType.UPPER),
    lower: createNamedWrapperReducer(upperLowerCircuit, EDrivingMarketSectionType.LOWER),
    weekHigh: createNamedWrapperReducer(weekHighLow, EDrivingMarketSectionType.WEEK_HIGH),
    weekLow: createNamedWrapperReducer(weekHighLow, EDrivingMarketSectionType.WEEK_LOW),
    volume: createNamedWrapperReducer(volumeBuzzer, EDrivingMarketSectionType.VOLUME),
    pullers: createNamedWrapperReducer(indexPullersDraggers, EDrivingMarketSectionType.PULLERS),
    draggers: createNamedWrapperReducer(indexPullersDraggers, EDrivingMarketSectionType.DRAGGERS),
});
